import {Injectable} from "@angular/core";
import {GeneralService} from "./generalService";
import {DICTIONARY} from "../dictionary";
import {Router} from "@angular/router";

const dic = DICTIONARY;

@Injectable({
    providedIn: 'root'
})
export class UserPermissionService {

	constructor(private gs:GeneralService,
				private router:Router) {
	}

	// updating variable that contains routes that are under construction and to be hidden in production
	hideInProductionRoutes = [

	];

	// CC: admin sections a technician (managed plans only) cannot open on the own plan (see runGlobalCheck)
	technicianOwnPlanBlockedStates = [
		dic.CONSTANTS.appStates.adminCenter,
		dic.CONSTANTS.appStates.adminOutbound,
		dic.CONSTANTS.appStates.adminInbound,
		dic.CONSTANTS.appStates.threatSimulation,
		dic.CONSTANTS.appStates.domainProtection,
		dic.CONSTANTS.appStates.collaborationProtection,
		dic.CONSTANTS.appStates.accountCompromised,
		dic.CONSTANTS.appStates.archive,
	];

	getPermission = (url) => {
		const userInfo = this.gs.userInfo;
		const urlSegments = url.split('/'); // => [section, page?, tab?]

		// global permission checks
		const globalCheckResult = this.runGlobalCheck(userInfo, url, urlSegments);
		if (globalCheckResult) {
			return globalCheckResult;
		}
		//

		switch (url) {
			case [dic.CONSTANTS.appStates.adminCenter].join('/'):
			case [dic.CONSTANTS.appStates.adminCenter, dic.CONSTANTS.adminPages.outbound.userPermissions].join('/'):
				return this.isAdminOrSubadmin();

			case [dic.CONSTANTS.appStates.adminCenter, dic.CONSTANTS.adminPages.outbound.userPermissions, dic.CONSTANTS.userPermissionsPageTabs.multiTenant].join('/'):
				return !!userInfo.plan.customer_id && (this.isAdminOrSubadmin() || !!userInfo.isPartnerReviewer);

			case [dic.CONSTANTS.appStates.adminOutbound].join('/'):
				return userInfo.plan.plan === dic.CONSTANTS.planTypePro && (this.isAdminOrSubadmin() || !!userInfo.isOutboundReviewer);

			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.sharedPlan].join('/'):
			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.userManagement].join('/'):
			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.lf].join('/'):
				return this.isAdminOrSubadmin() || (!!userInfo.global_reviewer?.outbound?.enabled && !!userInfo.outboundAllowChangeConfiguration);

			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.policyManagement, dic.CONSTANTS.outboundRulesAndPoliciesPageTabs.policies].join('/'):
				return this.isAdminOrSubadmin() || (!!userInfo.outboundAllowRules);

			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.policyManagement, dic.CONSTANTS.outboundRulesAndPoliciesPageTabs.emailSignatures].join('/'):
				return this.isAdminOrSubadmin() || (!!userInfo.outboundAllowEmailSignatures);

			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.trends].join('/'):
			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.report].join('/'):
				return this.isAdminOrSubadmin() || (!!userInfo.isOutboundReviewer && !!userInfo.outboundAllowChangeConfiguration);

			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.dataClassification].join('/'):
			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.quarantined].join('/'):
			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.auditLog].join('/'):
			case [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.emailTrace].join('/'):
				return this.isAdminOrSubadmin() || !!userInfo.isOutboundReviewer;

			// inbound
			case [dic.CONSTANTS.appStates.adminInbound].join('/'):
				return userInfo.plan.plan === dic.CONSTANTS.planTypePro && (this.isAdminOrSubadmin() || !!userInfo.isInboundReviewer || !this.isBkash());

			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.inboundShield].join('/'):
			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.urlTracking].join('/'):
				return this.isAdminOrSubadmin() || (!!userInfo.isInboundReviewer && !!userInfo.inboundAllowChangeConfiguration);

			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.plan].join('/'):
			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.mailboxes].join('/'):
			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.discoveredServices].join('/'):
				return this.isAdminOrSubadmin() || (!!userInfo.isInboundReviewer && !!userInfo.inboundAllowChangeConfiguration && !!userInfo.global_reviewer?.inbound?.enabled);

			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.trends].join('/'):
				return this.isAdminOrSubadmin() || ((userInfo.isInboundReviewer && userInfo.allowTrendsPage) || userInfo.global_reviewer?.inbound?.enabled);

			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.configuration].join('/'):
				return this.isAdminOrSubadmin() || ((userInfo.isInboundReviewer && userInfo.globalAllowBlockLists) || userInfo.global_reviewer?.inbound?.enabled);

			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.threatResponse].join('/'):
				return this.isAdminOrSubadmin() || ((userInfo.isInboundReviewer && userInfo.allowThreatResponse) || userInfo.global_reviewer?.inbound?.enabled);

			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.quarantined].join('/'):
			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.auditLog].join('/'):
			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.emailTrace].join('/'):
				return this.isAdminOrSubadmin() || !!userInfo.isInboundReviewer;

			// inbound (user)
			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.userInboundConf].join('/'):
				return !this.isAdminOrSubadmin() && !userInfo.isInboundReviewer && !!userInfo.plan.threat_protection?.whitelist_allow_recipient;

			case [dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.userQuarantinedInboundConf].join('/'):
				return !this.isAdminOrSubadmin() && !userInfo.isInboundReviewer;

			// Threat Simulation
			case [dic.CONSTANTS.appStates.threatSimulation].join('/'):
				return this.isAdminOrSubadmin() || !!userInfo.isThreatSimulationReviewer;

			// Domain Protection
			case [dic.CONSTANTS.appStates.domainProtection].join('/'):
				return this.isAdminOrSubadmin() || (!!userInfo.isInboundReviewer && !!userInfo.inboundAllowChangeConfiguration);

			// Collaboration Protection
			case [dic.CONSTANTS.appStates.collaborationProtection].join('/'):
				return this.isAdminOrSubadmin() || !!userInfo.isCollaborationProtectionReviewer;

			// Account Takeover Protection
			case [dic.CONSTANTS.appStates.accountCompromised].join('/'):
				return !!userInfo.plan.account_compromised?.enabled && (this.isAdminOrSubadmin() || !!userInfo.isAccountCompromisedReviewer);

			// Archive
			case [dic.CONSTANTS.appStates.archive].join('/'):
				return this.isAdminOrSubadmin() || !!userInfo.isArchiveReviewer;

			case [dic.CONSTANTS.appStates.archive, dic.CONSTANTS.adminPages.archive.trends].join('/'):
				return this.isAdminOrSubadmin() || ((userInfo.isArchiveReviewer && userInfo.archiveAllowTrendsPage));

			// Partners
			case [dic.CONSTANTS.appStates.partner].join('/'):
				return !!userInfo.plan.customer_id && (this.isAdminOrSubadmin() || !!userInfo.isPartnerReviewer);

			// Personal Pages
			case [dic.CONSTANTS.appStates.personalPages].join('/'):
				return !!userInfo.plan.allow_personal_nav_wa;

			case [dic.CONSTANTS.appStates.personalPages, dic.CONSTANTS.personalPages.composeMessage].join('/'):
			case [dic.CONSTANTS.appStates.personalPages, dic.CONSTANTS.personalPages.mailbox].join('/'):
			case [dic.CONSTANTS.appStates.personalPages, dic.CONSTANTS.personalPages.storage].join('/'):
			case [dic.CONSTANTS.appStates.personalPages, dic.CONSTANTS.personalPages.contacts].join('/'):
			case [dic.CONSTANTS.appStates.personalPages, dic.CONSTANTS.personalPages.templates].join('/'):
				return !(this.isBkash() && !this.isAdminOrSubadmin()); // not non-admin user in Bkash

			case [dic.CONSTANTS.appStates.personalPages, dic.CONSTANTS.personalPages.massList].join('/'):
				return !!userInfo.plan.methods.secure_mass;

			// Support Page
			case [dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.supportPages.tickets].join('/'):
				return !!userInfo.plan.allow_support_wa;

		}

		return true;
	}

	runGlobalCheck = (userInfo, fullUrl, urlSegments) => {
		// hide in production
		if (this.hideInProductionRoutes.includes(fullUrl) && this.gs.isProductionEnv()) {
			return false;
		}

		if (userInfo.type === dic.CONSTANTS.userTypes.dlp) {
			if ((urlSegments.length === 1 && urlSegments[0] === dic.CONSTANTS.appStates.adminOutbound) || (urlSegments.length > 1 && urlSegments[0] === dic.CONSTANTS.appStates.adminOutbound && urlSegments[1] === dic.CONSTANTS.adminPages.outbound.dataClassification)) {
				return true;
			}
			else {
				return this.router.createUrlTree([dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.dataClassification]);
			}
		}

		if (userInfo.type === dic.CONSTANTS.userTypes.heroku) {
			const allowedStates = [
				dic.CONSTANTS.appStates.home,
				dic.CONSTANTS.appStates.personalPages,
				dic.CONSTANTS.appStates.accountDetails,
				dic.CONSTANTS.appStates.knowledge,
			];
			if (!allowedStates.includes(urlSegments[0])) {
				return this.router.createUrlTree([allowedStates[0]]);
			}
		}

		// CC: technician (managed plans only) sub-admin: on the own plan only User Management (provisioning) and Partner pages are allowed,
		// CC: the rest of the admin sections are available through the multi-tenant selector (managed plans) - mirrors BE adminVerifier
		// CC: the guard checks every route layer (section, then section/page) - a layer that is a prefix of the user management path stays allowed
		const technicianOwnPlanPath = [dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.userManagement].join('/');
		if (userInfo.managed_plans_only && userInfo.user_role === dic.CONSTANTS.userRole.subAdmin && this.isTechnicianOnOwnPlan(userInfo) &&
			this.technicianOwnPlanBlockedStates.includes(urlSegments[0]) && !technicianOwnPlanPath.startsWith(fullUrl)) {
			return this.router.createUrlTree([dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.userManagement]);
		}

		if (userInfo.user_role === dic.CONSTANTS.userRole.user &&
			!userInfo.outboundAllowRules && urlSegments[0] === dic.CONSTANTS.appStates.adminOutbound
			&& urlSegments[1] === dic.CONSTANTS.adminPages.outbound.policyManagement &&
			urlSegments[2] === dic.CONSTANTS.outboundRulesAndPoliciesPageTabs.rules) {
			return this.router.createUrlTree([dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.policyManagement, dic.CONSTANTS.outboundRulesAndPoliciesPageTabs.reviewers]);
		}

		return null;
	}

	// CC: the selected tenant is the controlAdmin once the plan admins are loaded; before that (page refresh) the ?controlAdmin= URL param tells
	// CC: which managed plan is being opened - no param means the own plan
	isTechnicianOnOwnPlan = (userInfo) => {
		if (this.gs.controlAdmin) {
			return this.gs.controlAdmin.email === userInfo.email;
		}
		const urlControlAdmin = this.router.getCurrentNavigation()?.finalUrl?.queryParams?.['controlAdmin'] || this.router.parseUrl(this.router.url).queryParams['controlAdmin'];
		return !urlControlAdmin || urlControlAdmin === userInfo.email;
	}

	isAdminOrSubadmin = () => {
		return this.gs.userInfo.user_role === dic.CONSTANTS.userRole.admin || this.gs.userInfo.user_role === dic.CONSTANTS.userRole.subAdmin;
	}

	isBkash = () => {
		return this.gs.userInfo.plan._id.toString() === '650cc08cd74b1462095f319b';
	}
}
